import { css, cx } from "@emotion/css";
import { space, text, themeTokens } from "@octopusdeploy/design-system-tokens";
import { AnalyticLinkLocationProvider } from "@octopusdeploy/portal-analytics";
import { Fragment } from "react";
import * as React from "react";
import type { ReactElement, ReactNode } from "react";
import { useMediaQuery } from "react-responsive";
import { ContextualHelpLayout } from "~/components/ContextualHelpLayout/ContextualHelpLayout";
interface Level1EmptyStateLayoutProps {
    title: string;
    intro: ReactNode;
    actionButtonsAndLinks?: ReactElement[];
    image: ReactElement;
    analyticLocation?: string;
}
export function Level1EmptyStateLayout({ title, intro, image, actionButtonsAndLinks, analyticLocation }: Level1EmptyStateLayoutProps) {
    const isLargerThanIpad = useMediaQuery({ query: `(min-width: 811px)` });
    return (<AnalyticLinkLocationProvider location={analyticLocation ?? "Onboarding Page"}>
            <ContextualHelpLayout>
                <section className={cx(onboardingContainerStyles, { [onboardingContainerMobileStyles]: !isLargerThanIpad })}>
                    <div className={cx(infoStyles, { [infoMobileStyles]: !isLargerThanIpad })}>
                        <h1 className={titleStyles}>{title}</h1>
                        {intro}
                        {actionButtonsAndLinks && actionButtonsAndLinks.length !== 0 && (<div className={actionsContainerStyles}>
                                {actionButtonsAndLinks.map((item, index) => (<Fragment key={index}>{item}</Fragment>))}
                            </div>)}
                    </div>
                    <div className={cx(imageContainerStyles, { [imageContainerMobileStyles]: !isLargerThanIpad })}>{image}</div>
                </section>
            </ContextualHelpLayout>
        </AnalyticLinkLocationProvider>);
}
const onboardingContainerStyles = css({
    height: "100%",
    display: "flex",
    gap: space["32"],
    justifyContent: "center",
    alignItems: "center",
    color: themeTokens.color.text.primary,
});
const onboardingContainerMobileStyles = css({
    flexDirection: "column-reverse",
    padding: "1.5rem 1rem",
});
const infoStyles = css({
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    gap: space["24"],
    width: "31.25rem",
    font: text.interface.body.default.base,
});
const infoMobileStyles = css({
    width: "auto",
});
const titleStyles = css({
    all: "unset",
    font: text.interface.heading.large,
});
const actionsContainerStyles = css({
    display: "flex",
    gap: space["24"],
    alignItems: "center",
    flexWrap: "wrap",
});
const imageContainerStyles = css({
    width: "28.75rem",
    height: "28.75rem",
});
const imageContainerMobileStyles = css({
    width: "auto",
    height: "auto",
});
